import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { SaveSettingsInput } from '../../domain/dtos/settings'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class SaveSettings {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: SaveSettingsInput): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.PATCH,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input.productId}/settings/${input.type}`,
      body: { ...input.data },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }
}
